
import Color from './color';
import EleSvPanel from './components/ele-sv-panel';
import EleHueSlider from './components/ele-hue-slider';
import EleAlphaSlider from './components/ele-alpha-slider';
import ElePredefine from './components/ele-predefine';
import {DownOutlined, CloseOutlined} from '@ant-design/icons-vue';
import LocaleReceiver from 'ant-design-vue/es/locale-provider/LocaleReceiver';

export default {
  name: 'EleColorPicker',
  components: {
    EleSvPanel,
    EleHueSlider,
    EleAlphaSlider,
    ElePredefine,
    DownOutlined,
    CloseOutlined,
    LocaleReceiver
  },
  emits: [
    'change',
    'active-change',
    'update:value'
  ],
  props: {
    // 绑定的颜色, v-model
    value: String,
    // 绑定的颜色格式, hsl / hsv / hex / rgb
    colorFormat: String,
    // 是否支持透明度选择
    showAlpha: Boolean,
    // 预定义颜色
    predefine: Array,
    // 尺寸
    size: String,
    // 是否禁用
    disabled: Boolean,
    // 自定义下拉框类名
    popperClass: String,
    // 自定义类名
    customClass: String
  },
  data() {
    const color = new Color({
      enableAlpha: this.showAlpha,
      format: this.colorFormat
    });
    let displayValue = null;
    if (this.value) {
      color.fromString(this.value);
      displayValue = color.value;
    }
    return {
      // 颜色封装
      color: color,
      // 色相
      colorHue: color._hue,
      // 饱和度
      colorSaturation: color._saturation,
      // 明度
      colorValue: color._value,
      // 透明度
      colorAlpha: color._alpha,
      // rgb
      colorRgb: color.toRgb(),
      // 输入的颜色值
      inputValue: displayValue,
      // 当前显示的颜色值
      displayValue: displayValue,
      // 是否显示popper
      showPicker: false
    };
  },
  computed: {
    triggerClass() {
      return [
        'ele-bg-white ele-border-split ele-color-picker-trigger',
        {'ele-color-picker-large': this.size === 'large'},
        {'ele-color-picker-small': this.size === 'small'},
        {'is-disabled': this.disabled},
        this.customClass
      ];
    },
    predefineColors() {
      return this.predefine && this.predefine.map((value) => {
        const c = new Color({
          enableAlpha: this.showAlpha,
          format: this.colorFormat
        });
        c.fromString(value);
        return c.value;
      });
    }
  },
  methods: {
    /* 确定 */
    confirmValue() {
      this.$emit('update:value', this.color.value);
      this.$emit('change', this.color.value);
      this.$emit('active-change', this.color.value);
      this.showPicker = false;
    },
    /* 清空 */
    clearValue() {
      this.$emit('update:value', null);
      this.$emit('change', null);
      this.$emit('active-change', null);
      this.inputValue = null;
      this.displayValue = null;
      this.showPicker = false;
    },
    /* 色相改变处理 */
    handleHChange(value) {
      this.color.set('_hue', value);
      this.colorHue = this.color._hue;
      this.colorRgb = this.color.toRgb();
      this.inputValue = this.color.value;
      this.displayValue = this.color.value;
      this.$emit('active-change', this.color.value);
    },
    /* 饱和度和明度改变处理 */
    handleSVChange(obj) {
      this.color.set({
        _saturation: obj.saturation,
        _value: obj.value
      });
      this.colorSaturation = this.color._saturation;
      this.colorValue = this.color._value;
      this.colorRgb = this.color.toRgb();
      this.inputValue = this.color.value;
      this.displayValue = this.color.value;
      this.$emit('active-change', this.color.value);
    },
    /* 透明度改变处理 */
    handleAChange(value) {
      this.color.set('_alpha', value);
      this.colorAlpha = this.color._alpha;
      this.inputValue = this.color.value;
      this.displayValue = this.color.value;
      this.$emit('active-change', this.color.value);
    },
    /* 颜色改变处理 */
    handleColorChange(value) {
      if (value) {
        if (value !== this.color.value) {
          this.color.fromString(value);
          this.colorHue = this.color._hue;
          this.colorSaturation = this.color._saturation;
          this.colorValue = this.color._value;
          this.colorAlpha = this.color._alpha;
          this.colorRgb = this.color.toRgb();
        }
        this.inputValue = this.color.value;
        this.displayValue = this.color.value;
        this.$emit('active-change', this.color.value);
      }
    },
    /* 颜色输入改变处理 */
    handleInput() {
      if (this.inputValue) {
        this.handleColorChange(this.inputValue);
      } else {
        this.inputValue = this.color.value;
        this.displayValue = this.color.value;
        this.$emit('active-change', this.color.value);
      }
    },
    /* picker展开/关闭处理 */
    handleVisibleChange(visible) {
      if (!visible) {
        if (this.value) {
          this.handleColorChange(this.value);
        } else {
          this.inputValue = null;
          this.displayValue = null;
          this.$emit('active-change', null);
        }
      }
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.handleColorChange(value);
      } else {
        this.inputValue = null;
        this.displayValue = null;
        this.$emit('active-change', null);
      }
    },
    colorFormat(value) {
      this.color.set('format', value);
      this.inputValue = this.color.value;
      this.displayValue = this.color.value;
      this.$emit('active-change', this.color.value);
    },
    showAlpha(value) {
      this.color.set('enableAlpha', value);
      this.inputValue = this.color.value;
      this.displayValue = this.color.value;
      this.$emit('active-change', this.color.value);
    }
  }
};
